import React from "react";
import { partners } from "../mock";
import { CheckCircle2 } from "lucide-react";

export default function TrustBar() {
  const doubled = [...partners, ...partners];
  return (
    <section className="py-10 bg-white border-y border-[#e6ded0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12">
          <div className="text-xs uppercase tracking-widest text-[#0e3a3f]/50 font-medium whitespace-nowrap">
            Reconnu par
          </div>
          <div className="flex-1 overflow-hidden w-full">
            <div className="flex gap-12 animate-marquee w-max">
              {doubled.map((p, i) => (
                <div key={`${p}-${i}`} className="flex items-center gap-2 text-[#0e3a3f]/70 whitespace-nowrap">
                  <CheckCircle2 className="w-4 h-4 text-[#2c7a80]" />
                  <span className="font-medium text-sm">{p}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
